<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_sales'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_filter" class="dataTables_filter text-md-start">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input v-model="filter" type="search" placeholder="Search by Transaction ID..."
                      class="form-control form-control-sm"></b-form-input>
                    <button @click.prevent="searchTransaction" class="btn btn-sm btn-primary ms-2">
                      <i class="mdi mdi-magnify"></i>
                    </button>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <div class="paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="total_sales" :per-page="perPage"
                      @input="() => { }"></b-pagination>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 justify-content-end">
                <div class="row justify-content-end align-items-center">
                  <div class="col-9 d-flex">
                    <multiselect @input="fetchUserTransactions" v-model="user" label="username" :options="users"
                      placeholder="Filter by User..."></multiselect>
                    <button @click="clearFilters" v-if="user" class="btn btn-danger"><i class="mdi mdi-filter-remove-outline"></i></button>
                  </div>
                  <div class="col-3">
                    <button @click.prevent="refreshCart" class="btn btn-sm btn-primary"
                      :class="{ disabled: loader5 }">
                      <b-spinner v-if="loader5" small class="mr-1" label="Small Spinner" />
                      <div v-else><i class="mdi mdi-refresh"></i></div>
                    </button>
                  </div>
                </div>

              </div>
            </div>
            <div class="table-responsive">
              <b-table class="text-center" :items="Items" :fields="Fields" responsive="sm" :per-page="perPage"
                :current-page="1" :filter-included-fields="filterOn" @filtered="Filtered"
                :busy="IsBusy">
                <template #table-busy>
                  <div class="text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + currentPage * 100 - 99 }}
                </template>
                <template #cell(transaction_id)="data">
                  {{ data.item.transaction_id }}
                </template>
                <template #cell(customer)="data">
                  {{ data.item.customer.name || "-" }}
                </template>
                <template #cell(date_added)="data">
                  {{ data.item.date_added }}
                </template>

                <template #cell(price_paid)="data">
                  <div class="text-danger" v-if="data.item.price_paid < data.item.cost">
                    <span>{{ commas(data.item.price_paid) }}</span>
                  </div>

                  <div v-else>
                    <span class="text-success fw-bold">{{
                      commas(data.item.cost)
                      }}</span>
                  </div>
                </template>
                <template #cell(balance)="data">
                  <div v-if="data.item.price_paid < data.item.cost">
                    {{ data.item.cost - data.item.price_paid }}<br />
                    <button class="btn btn-sm btn-primary" @click.prevent="
                      getTransaction(
                        data.item.transaction_id,
                        data.item.cost - data.item.price_paid,
                        data.item.customer.id
                      )
                      ">
                      <span v-if="loader2"><b-spinner small class="mr-1" label="Small Spinner" /></span>
                      <span v-else><i class="mdi mdi-cash"></i> <b>Pay</b></span>
                    </button>
                  </div>
                  <div class="text-primary" v-else>
                    <i class="fas fa-check"></i> Paid
                  </div>
                </template>
                <template #cell(cost)="data">
                  {{ commas(data.item.cost) }}
                </template>
                <template #cell(added_by)="data">
                  {{ data.item.added_by }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn">
                    <b-button @click="
                      edit(data.item.transaction_id, data.item.price_paid)
                      " type="button" class="btn-sm btn" :class="{
                        'disabled btn-secondary': !userData.permissions[
                          'view_sale_details'
                        ],
                      }" variant="info" v-b-modal.edit>
                      <span v-if="loader"><b-spinner small class="mr-1" label="Small Spinner" /></span>
                      <span v-else><i class="mdi mdi-eye"></i> view</span></b-button>
                    <router-link :to="{
                      path: '/printreciept',
                      query: {
                        id: data.item.transaction_id,
                      },
                    }" type="button" class="btn-sm btn btn-success">
                      <span><i class="mdi mdi-printer"></i></span></router-link>
                    <b-button @click="
                      remove(data.item.transaction_id)
                      " type="button" class="btn-sm btn" variant="danger" v-b-modal.delete>
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>

              </b-table>
              <div class="row mt-3">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="view-visit" centered title="View Sale Details" title-class="font-14" hide-footer size="lg">
      <table class="table table-sm mt-2 table-hover text-center align-middle" style="color: black;" density="compact">
        <thead>
          <tr>
            <!-- <th>Transaction ID</th> -->
            <th>#</th>
            <th>Product</th>
            <th>Unit Sold</th>
            <th>Quantity</th>
            <th>Total Prices</th>
            <th>Profit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in salesdetails" :key="index">
            <!-- <td>{{ item.transaction_id }}</td> -->
            <td>{{ index + 1 }}</td>
            <td>
              {{ item.product }}
            </td>
            <td>{{ item.unit }}</td>
            <td>{{ item.quantity }}</td>
            <td>
              <div class="text-danger fw-bold">
                Sell Price: {{ commas(item.price * item.quantity) }}
              </div>
              <div class="text-primary fw-bold">
                Buy Price:
                {{
                  commas(item.buying_price * item.quantity * item.base_quantity)
                }}
              </div>
            </td>
            <td class="text-success fw-bold">
              UGX.
              {{
                commas(
                  item.price * item.quantity -
                  item.buying_price * item.quantity * item.base_quantity
                )
              }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="danger" @click="$bvModal.hide('view-visit')">Close</b-button>
      </div>
    </b-modal>

    <b-modal id="view-pay" centered title="Balance Payment" title-class="font-14" hide-footer>
      <form @submit.prevent="editPayment">
        <input v-model="transaction_id" type="hidden" />
        <div class="form-group mb-2">
          <label>Total Amount</label>
          <input readonly v-model="balance" type="number" class="form-control" min="0" />
        </div>
        <!--  <div class="form-group mb-2">
          <label>Amount Paid</label>
          <input  readonly :value="balance1" type="number" class="form-control" min="0" />
        </div>  -->

        <div class="form-group mb-2">
          <label>Amount Received</label>
          <input v-model.number="amount_received" type="number" class="form-control" min="0"
            @input="calculateBalanceAndChange" />
        </div>
        <br>
        <div class="d-flex justify-content-between align-items-start">
          <div class="form-group mb-2 text-start">
            <label :class="{ 'text-success': isCharge, 'text-danger': !isCharge }">{{ isCharge ? 'Charge' : 'Balance'
              }}</label>
            <p :class="{ 'text-success': isCharge, 'text-danger': !isCharge }" class="form-control-static">
              {{ balanceOrChange }}
            </p>
          </div>
          <div class="col-md-6 text -end">
            <div class="form-group">
              <div class="mb-2 d-flex align-items-center">
                <div class="float-end">
                  <b-button v-if="useCustomer && userData.permissions['add_customer'] == 1" class="py-1 me-1 btn-sm"
                    v-b-modal.new-customer variant="primary"><i class="mdi mdi-plus"></i>
                  </b-button>
                </div>
                <div class="fw-bold">Known Customer</div>
                <input type="checkbox" v-model="useCustomer" @click="getCustomers" class="ms-1" />
              </div>
              <multiselect v-if="useCustomer" v-model="customer" label="name" :options="customers">
              </multiselect>
              <input v-else readonly value="Random Customer" class="form-control" />
            </div>
          </div>
        </div>
        <b-modal id="new-customer" title="Add New Customer" hide-footer>

          <form @submit.prevent="addCustomer">
            <div class="form-group mb-2">
              <label>Customer Name</label>
              <input v-model="name" type="text" required class="form-control" />
            </div>
            <div class="form-group mb-2">
              <label>Email</label>
              <input v-model="email" type="email" class="form-control" />
            </div>
            <div class="row">
              <div class="col-md-6 form-group mb-2">
                <label for="contact">Contact</label>
                <input type="text" class="form-control" id="contact" v-model="contact" placeholder="123-45-678"
                  required />
              </div>
              <div class="col-md-6 form-group mb-2">
                <label>Location</label>
                <input v-model="location" class="mb-3 form-control" value-field="id" text-field="name" />
              </div>
            </div>
            <div class="form-group d-flex justify-content-end">
              <b-button type="button" class="btn w-30" variant="secondary"
                @click="$bvModal.hide('new-customer')">Close</b-button>
              <b-button type="submit" class="btn ms-1 w-30" variant="primary">
                <i class="fas fa-check-circle"></i> Submit
              </b-button>
            </div>
          </form>
        </b-modal>
        <div class="form-group mb-2">
          <label>Payment Method</label>
          <multiselect required v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Pay Date</label>
          <input required v-model="paydate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('view-pay')">Close</b-button>

          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            v-show="(useCustomer && customer && amount_received >= 0) || (!useCustomer && amount_received >= balance)">
            <span v-if="loader3"><b-spinner small class="mr-1" label="Small Spinner" /></span>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="delete-unit" centered title="Delete From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
        <input v-model="transaction_id" type="hidden" />
        Are you sure you want to remove this Transaction : <b>{{ transaction_id }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :class="{ disabled: loader4 }"
            :disabled="loader4">
            <b-spinner v-if="loader4" small class="mr-1" label="Small Spinner" />
            <i v-else class="fas fa-check-circle"></i> YES
          </b-button>

        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  saleComputed,
  saleMethods,
  paymentoptionComputed,
  paymentoptionMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "View Sales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Sales",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Sales", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 100,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true, tdClass: "align-middle" },
        { key: "id", label: "ID", visible: false, tdClass: "align-middle" },
        {
          key: "transaction_id",
          label: "Trans ID",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "customer",
          label: "Customer",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "cost",
          label: "Total Cost",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "price_paid",
          label: "Price Paid",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "balance",
          label: "Balance",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "added_on",
          label: "Date added",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "addedby",
          label: "Added by",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "actions",
          label: "Actions",
          visible: true,
          tdClass: "align-middle",
        },
      ],
      salesdetails: [],
      id: "",
      transaction_id: "",
      telephone: "",
      name: "",
      nationality: "",
      gender: "",
      address: "",
      dateofbirth: "",
      total: 0,
      invest: 0,
      cost: 0,
      payment_method: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      customer: "",
      account_received: 0,
      balance: "",
      balance_to_pay: 0,
      // Loaders
      loader: "", // for viewing sale details
      loader2: "", // for pay balance button
      loader3: "", // for submiting balance
      loader5: false, // refresh cart
      loader4: false, // for the delete sale
      balanceOrChange: 0,
      isCharge: false,
      total_amount: 0,
      amount_received: '',
      useCustomer: false,
      customers: [{ name: "Trevor" }, { name: "McDaniel" }],
      email: '',
      location: '',
      contact: '',
      total_sales: 0, // Total Sales in the database. For purposes of counting
      user: null,
      users: []
    };
  },
  watch: {
    currentPage(newPage) {
      this.fetchSales({ page: newPage, user: this.user ? this.user.id : null });
    },

    filter(newFilter) {
      if (newFilter === null || newFilter === "") {
        this.fetchSales({});
      }
    },
  },
  computed: {
    ...saleComputed,
    ...paymentoptionComputed,
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      if (this.isBusy) {
        return [];
      }
      return this.sales.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.sales.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },

    labelForBalanceOrChange() {
      return this.amount_received >= this.balance ? 'Change' : 'Balance to Pay';
    },


  },
  mounted() {
    this.List();
    this.fetchSales({});
    this.fetchPaymentoptions();
    this.TotalRows = this.sales.length;
    this.isBusy = false;
    this.payment_method = this.paymentoptions.find(
      (option) => option.set_default == 1
    );
    this.getUsers();
  },
  methods: {
    ...paymentoptionMethods,

    List(user = null) {
      const userParam = user ? `/${user}` : '';
      axios.get(`/count-sales${userParam}`).then((response) => {
        this.total_sales = response.data.count;
      });
    },

    getUsers() {
      axios.get("/users").then((response) => {
        this.users = response.data.users;
      });
    },

    fetchUserTransactions() {
      this.fetchSales({ page: this.currentPage, user: this.user ? this.user.id : null });
    },

    searchTransaction() {
      if (this.filter) {
        this.currentPage = 1;
        this.user = null;
        this.getSale(this.filter)
      }
    },

    clearFilters(){
      this.user = null;
      this.fetchSales({});
    },

    remove(transaction_id) {
      this.transaction_id = transaction_id;

      this.$bvModal.show("delete-unit");
    },
    async refreshCart() {
      this.loader5 = true;
      await this.fetchSales({ page: this.currentPage, user: this.user ? this.user.id : null });
      this.loader5 = false;

    },
    async calculateBalanceAndChange() {
      const received = this.amount_received;

      if (received > this.balance) {
        this.balanceOrChange = received - this.balance; // Charge
        this.isCharge = true;
        this.balance1 = received - this.balanceOrChange;
      } else {
        this.balanceOrChange = this.balance - received; // Balance to pay
        this.isCharge = false;
        this.balance1 = received;
      }
    },

    async editPayment() {
      this.loader3 = true;
      let newForm = new FormData();
      newForm.append("transaction_id", this.transaction_id);
      newForm.append("customer", this.useCustomer ? this.customer.id : 0,);
      // newForm.append("balance", this.balance);
      newForm.append("balance", this.balance1);
      newForm.append("paymentoption", this.payment_method.id);
      newForm.append("pay_date", this.paydate);
      let url = "/pay_balance";
      const response = await axios.post(url, newForm);
      if (response) {
        this.$bvModal.hide("view-pay");
        this.$toast.success("Updated Sale Payemnt!");
        this.fetchSales({ page: this.currentPage, user: this.user ? this.user.id : null });
      }
      this.loader3 = false;
    },

    async getTransaction(trans_id, balance, customer) {
      this.loader2 = true;
      let url = `payment/${trans_id}`;
      this.transaction_id = trans_id;
      this.balance = balance;
      this.customer = customer;
      const response = await axios.get(url);
      if (response) {
        this.$bvModal.show("view-pay");
      }
      this.loader2 = false;
    },
    async removeFromCart() {
      this.loader4 = true;
      let formData = new FormData();
      formData.append("transaction_id", this.transaction_id);
      let url = "/deletefromsales";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSales({ page: this.currentPage, user: this.user ? this.user.id : null });
          this.loader4 = false
          this.error = '';
          this.$bvModal.hide("delete-unit");
        }
      });
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    ...saleMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async getCustomers() {
      if (!this.useCustomer) {
        const customers = await axios.get("/customers");
        this.customers = customers.data.customers;
      }
    },
    async addCustomer() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("contact", this.contact);
      formData.append("location", this.location);
      formData.append("email", this.email);
      let url = "/create_customer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$bvModal.hide("new-customer");
          this.name = "";
          this.contact = "";
          this.email = "";
          this.location = "";
        }
      });
      const customers = await axios.get("/customers");
      this.customers = customers.data.customers;
    },
    async edit(transaction_id, price_paid) {
      this.loader = true;
      this.total = price_paid;
      this.transaction_id = transaction_id;
      let url = `/orderbyid/${this.transaction_id}`;
      await axios.get(url).then((response) => {
        if (response.status == 200) {
          this.salesdetails = response.data.orders;
          this.invest = 0;
          this.cost = 0;
          this.salesdetails.forEach((element) => {
            this.invest = this.invest + element.buying_price * element.quantity;
            this.cost = this.cost + element.selling_price * element.quantity;
          });
          this.$bvModal.show("view-visit");
        }
        this.loader = false;
      });
    },
  },
};
</script>
